(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mfc-family-enquiry"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialise = (root) => {
    root.querySelectorAll('form[data-mfc-consent-buttons]').forEach((form) => {
      if (form.dataset.mfcConsentReady) return;
      const buttons = [...form.querySelectorAll('button[data-mfc-marketing-choice]')];
      if (buttons.length !== 2) return;
      const choice = document.createElement('input');
      choice.type = 'hidden';
      choice.name = 'contact[Optional school marketing]';
      choice.value = 'No';
      form.append(choice);
      const setChoice = (button) => {
        choice.value = button.dataset.mfcMarketingChoice === 'Yes' ? 'Yes' : 'No';
        const status = form.querySelector('[data-mfc-consent-status]');
        if (status) status.textContent = button.dataset.mfcMarketingStatus;
      };
      buttons.forEach((button) => {
        button.removeAttribute('name');
        button.addEventListener('click', () => setChoice(button), true);
      });
      form.addEventListener('submit', (event) => {
        const submitter = event.submitter;
        if (submitter?.matches('button[data-mfc-marketing-choice]')) {
          setChoice(submitter);
        }
      }, true);
      form.dataset.mfcConsentReady = 'true';
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  } else {
    initialise(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
